


import React, { useState } from "react";
import { Search } from "@mui/icons-material";


const SearchRequests = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (event) => {
    const term = event.target.value;
    setSearchTerm(term);
    onSearch(term); // Pass the search term to the parent component
  };

  return (

            <div className="search-container">
            <span className="searchbarcontainer">
                <input type="search" placeholder="Search..." value={searchTerm} onChange={handleSearchChange}/>
                {/* <Search /> */}
                <button type="submit"><Search /></button>
            </span>
           </div>
  );
};

export default SearchRequests;
